module.exports = __webpack_public_path__ + "img/nav-logo.15254344.png";